import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import DashFooter from '../../Header/DashFooter';
import Footer from '../../Header/Footer';
import Header from '../../Header/Header';
import Preloader from '../../Preloder/Preloader';

const UserViewProfile = () => {
    const location =useLocation()
    const data = location.state || {};
    console.log("locate ",location.state)

    useEffect(() => {
  window.scrollTo(0, 0);
}, []);

  return (
    <div>
      
    {/* PRELOADER */}
    <Preloader/>
    <div class="pop-bg"></div>
    {/* END PRELOADER */}

    {/* SEARCH */}
    <div class="pop-search">
        <span class="ser-clo">+</span>
        <div class="inn">
            <form>
                <input type="text" placeholder="Search here..."/>
            </form>
            <div class="rel-sear">
                <h4>Top searches:</h4>
                <a href="all-profiles.html">Browse all profiles</a>
                <a href="all-profiles.html">Mens profile</a>
                <a href="all-profiles.html">Female profile</a>
                <a href="all-profiles.html">New profiles</a>
            </div>
        </div>
    </div>
    {/* END PRELOADER */}

   <Header/>

    {/* PROFILE */}
    <section>
        <div class="profi-pg profi-ban">
            <div class="">
                <div class="">
                    <div class="profile">
                        <div class="pg-pro-big-im">
                            <div class="s1">
                                <img src={
  data.user_photo
    ? `${process.env.REACT_APP_API}/uploads/${data.user_photo}`
    :  process.env.PUBLIC_URL + "/images/user/user.png" 
} loading="lazy" class="pro" alt=""/>
                            </div>
                            <div class="s3">
                                <a href="#!" class="cta fol cta-chat">Chat now</a>
                                <span class="cta cta-sendint" data-toggle="modal" data-target="#sendInter">Send
                                    interest</span>
                            </div>
                        </div>
                    </div>
                    <div class="profi-pg profi-bio">
                        <div class="lhs">
                            <div class="pro-pg-intro">
                                <h1>{data.full_name}</h1>
                                <div class="pro-info-status">
                                    <span class="stat-1"><b>100</b> viewers</span>
                                    <span class="stat-2"><b>Available</b> online</span>
                                </div>
                                <ul>
                                    {/* <li>
                                        <div>
                                            <img src="images/icon/pro-city.png" loading="lazy" alt=""/>
                                            <span>City: <strong>New York</strong></span>
                                        </div>
                                    </li> */}
                                    <li>
                                        <div>
                                            <img src={process.env.PUBLIC_URL + "/images/icon/pro-age.png"}  loading="lazy" alt=""/>
                                            <span>Age: <strong>{data.age}</strong></span>
                                        </div>
                                    </li>
                                    <li>
                                        <div>
                                            <img src={process.env.PUBLIC_URL + "/images/icon/pro-city.png"}loading="lazy" alt=""/>
                                            <span>Height: <strong>5.7</strong></span>
                                        </div>
                                    </li>
                                    <li>
                                        <div>
                                            <img src={process.env.PUBLIC_URL + "/images/icon/pro-city.png"} loading="lazy" alt=""/>
                                            <span>Job: <strong>{data.employeid}</strong></span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            {/* PROFILE ABOUT */}
                            {/* <div class="pr-bio-c pr-bio-abo">
                                <h3>About</h3>
                                <p>It is a long established fact that a reader will be distracted by the readable
                                    content of a page when looking at its layout. The point of using Lorem Ipsum is that
                                    it has a more-or-less normal distribution of letters, as opposed to using 'Content
                                    here, content here', making it look like readable English. </p>
                                <p>Many desktop publishing packages and web page editors now use Lorem Ipsum as their
                                    default model text.</p>
                            </div> */}
                            {/* END PROFILE ABOUT */}
                            {/* PROFILE ABOUT */}
                            {/* <div class="pr-bio-c pr-bio-gal" id="gallery">
                                <h3>Photo gallery</h3>
                                <div id="image-gallery">
                                    <div class="pro-gal-imag">
                                        <div class="img-wrapper">
                                            <a href="#!"><img src="images/profiles/1.jpg" class="img-responsive" alt=""/></a>
                                            <div class="img-overlay"><i class="fa fa-arrows-alt" aria-hidden="true"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="pro-gal-imag">
                                        <div class="img-wrapper">
                                            <a href="#!"><img src="images/profiles/6.jpg" class="img-responsive" alt=""/></a>
                                            <div class="img-overlay"><i class="fa fa-arrows-alt" aria-hidden="true"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="pro-gal-imag">
                                        <div class="img-wrapper">
                                            <a href="#!"><img src="images/profiles/14.jpg" class="img-responsive" alt=""/></a>
                                            <div class="img-overlay"><i class="fa fa-arrows-alt" aria-hidden="true"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            {/* END PROFILE ABOUT */}
                            {/* PROFILE ABOUT */}
                            {/* <div class="pr-bio-c pr-bio-conta">
                                <h3>Contact info</h3>
                                <ul>
                                    <li><span><i class="fa fa-mobile"
                                                aria-hidden="true"></i><b>Phone:</b>+92 (8800) 68 - 8960</span></li>
                                    <li><span><i class="fa fa-envelope-o"
                                                aria-hidden="true"></i><b>Email:</b>angelinajoliewed@gmail.com</span>
                                    </li>
                                    <li><span><i class="fa fa fa-map-marker" aria-hidden="true"></i><b>Address: </b>28800
                                            Orchard Lake Road, Suite 180 Farmington Hills, U.S.A.</span></li>
                                </ul>
                            </div> */}
                            {/* END PROFILE ABOUT */}
                            {/* PROFILE ABOUT */}
                            <div class="pr-bio-c pr-bio-info">
                                <h3>Personal information</h3>
                                <ul>
                                    <li><b>Name:</b> {data.full_name}</li>
                                    <li><b>Fatheres name:</b> {data.father_name}</li>
                                    {/* <li><b>Family name:</b> Joney family</li> */}
                                    <li><b>Age:</b> {data.age}</li>
                                    <li><b>Date of birth:</b>{data.dateofbirth}</li>
                                    <li><b>Height:</b>167cm</li>
                                    <li><b>Weight:</b>65kg</li>
                                    <li><b>Education :</b> {data.education}</li>
                                    <li><b>Religion:</b> {data.religion_name}</li>
                                    <li><b>Profession:</b> {data.job_type}</li>
                                    {/* <li><b>Company:</b> Google</li> */}
                                    {/* <li><b>Position:</b> Web developer</li> */}
                                    <li><b>Cast:</b> {data.caste_name}</li>
                                </ul>
                            </div>
                            {/* END PROFILE ABOUT */}
                            {/* PROFILE ABOUT */}
                            {/* <div class="pr-bio-c pr-bio-hob">
                                <h3>Hobbies</h3>
                                <ul>
                                    <li><span>Modelling</span></li>
                                    <li><span>Watching movies</span></li>
                                    <li><span>Playing volleyball</span></li>
                                    <li><span>Hangout with family</span></li>
                                    <li><span>Adventure travel</span></li>
                                    <li><span>Books reading</span></li>
                                    <li><span>Music</span></li>
                                    <li><span>Cooking</span></li>
                                    <li><span>Yoga</span></li>
                                </ul>
                            </div> */}
                            {/* END PROFILE ABOUT */}
                            {/* PROFILE ABOUT */}
                            {/* <div class="pr-bio-c menu-pop-soci pr-bio-soc">
                                <h3>Social media</h3>
                                <ul>
                                    <li><a href="#!"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
                                    <li><a href="#!"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
                                    <li><a href="#!"><i class="fa fa-whatsapp" aria-hidden="true"></i></a></li>
                                    <li><a href="#!"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
                                    <li><a href="#!"><i class="fa fa-youtube-play" aria-hidden="true"></i></a></li>
                                    <li><a href="#!"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
                                </ul>
                            </div> */}
                            {/* END PROFILE ABOUT */}


                        </div>

                        {/* PROFILE lHS */}
                        
                        {/* END PROFILE lHS */}
                    </div>
                </div>
            </div>
        </div>
    </section>
    {/* END PROFILE */}

    {/* INTEREST POPUP */}
    <div class="modal fade" id="sendInter">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">

                {/* Modal Header */}
                <div class="modal-header">
                    <h4 class="modal-title seninter-tit">Send interest to <span class="intename">Jolia</span></h4>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>

                {/* Modal body */}
                <div class="modal-body seninter">
                    <div class="lhs">
                        <img src="images/profiles/1.jpg" alt="" class="intephoto1" />
                    </div>
                    <div class="rhs">
                        <h4><span class="intename1">Jolia</span> Can able to view the below details</h4>
                        <ul>
                            <li>
                                <div class="chbox">
                                    <input type="checkbox" id="pro_about" checked=""/>
                                    <label for="pro_about">About section</label>
                                </div>
                            </li>
                            <li>
                                <div class="chbox">
                                    <input type="checkbox" id="pro_photo"/>
                                    <label for="pro_photo">Photo gallery</label>
                                </div>
                            </li>
                            <li>
                                <div class="chbox">
                                    <input type="checkbox" id="pro_contact"/>
                                    <label for="pro_contact">Contact info</label>
                                </div>
                            </li>
                            <li>
                                <div class="chbox">
                                    <input type="checkbox" id="pro_person"/>
                                    <label for="pro_person">Personal info</label>
                                </div>
                            </li>
                            <li>
                                <div class="chbox">
                                    <input type="checkbox" id="pro_hobbi"/>
                                    <label for="pro_hobbi">Hobbies</label>
                                </div>
                            </li>
                            <li>
                                <div class="chbox">
                                    <input type="checkbox" id="pro_social"/>
                                    <label for="pro_social">Social media</label>
                                </div>
                            </li>
                        </ul>
                        <div class="form-floating">
                            <textarea class="form-control" id="comment" name="text"
                                placeholder="Comment goes here"></textarea>
                            <label for="comment">Write some message to <span class="intename"></span></label>
                        </div>
                    </div>
                </div>

                {/* Modal footer */}
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary">Send interest</button>
                    <button type="button" class="btn btn-outline-danger" data-dismiss="modal">Cancel</button>
                </div>

            </div>
        </div>
    </div>
    {/* END INTEREST POPUP */}

    {/*- CHAT CONVERSATION BOX START -*/}
    <div class="chatbox">
        <span class="comm-msg-pop-clo"><i class="fa fa-times" aria-hidden="true"></i></span>

        <div class="inn">
            <form name="new_chat_form" method="post">
                <div class="s1">
                    <img src="images/profiles/2.jpg" class="intephoto2" alt=""/>
                    <h4><b>{data.full_name}</b>,</h4>
                    <span class="avlsta avilyes">Available online</span>
                </div>
                <div class="s2 chat-box-messages">
                    <span class="chat-wel">Start a new chat!!! now</span>
                    <div class="chat-con">
                        <div class="chat-lhs">Hi</div>
                        <div class="chat-rhs">Hi</div>
                    </div>
                    {/*<span>Start A New Chat!!! Now</span>*/}
                </div>
                <div class="s3">
                    <input type="text" name="chat_message" placeholder="Type a message here.." required=""/>
                    <button id="chat_send1" name="chat_send" type="submit">Send <i class="fa fa-paper-plane-o"
                            aria-hidden="true"></i>
                    </button>
                </div>
            </form>
        </div>
    </div>
    {/*- END -*/}

  <Footer/>
  

    </div>
  )
}

export default UserViewProfile
